export const APP_CONFIG = {
  name: "Zone Admin Console",
  shortName: "Zone Admin",
  // Conservative TTLs for operational data. Adjust per-query where needed.
  defaultQueryStaleTimeMs: 15_000,
  defaultQueryGcTimeMs: 5 * 60_000,
  // Dangerous admin actions must NEVER be optimistic. This flag is enforced
  // by useDangerousMutation — do not flip without a re-design.
  optimisticDangerousActions: false,
  // Proactively refresh the admin access token on this interval while a tab is
  // open and authenticated, so an idle operator never gets logged out. The
  // backend access token lives ~10 min; refreshing every 8 min keeps it fresh
  // with margin. Renewal is silent and reuses the rotating refresh token.
  adminTokenRefreshIntervalMs: 8 * 60_000,
} as const;
